import React from 'react';
import { Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Expertise', href: '/expertise' },
    { name: 'Why SP GxP', href: '/why' },
    { name: 'Contact', href: '/contact' }
  ];

  return (
    <footer className="bg-navy-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          
          {/* Left - Logo & Tagline */}
          <div className="space-y-4">
            <div>
              <div className="text-2xl font-bold">
                SP <span className="text-blue-400">GxP</span>
              </div>
              <div className="text-sm text-gray-300 -mt-1">Consultants</div>
            </div>
            <p className="text-blue-300 font-medium text-lg">
              "Practical GMP. Predictable Outcomes."
            </p>
            <p className="text-gray-300 text-sm leading-relaxed">
              GxP excellence for pharma and biotech—delivered without surprises.
            </p>
          </div>

          {/* Middle - Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <div className="grid grid-cols-2 gap-2">
              {quickLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200 text-sm"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          {/* Right - Legal & Social */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-white">Connect</h3>
            
            <div className="flex items-center space-x-4">
              <a
                href="https://linkedin.com/company/sp-gxp-consultants"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-300 hover:text-blue-400 transition-colors duration-200"
              >
                <Linkedin className="h-5 w-5" />
                <span className="text-sm">LinkedIn</span>
              </a>
            </div>

            <div className="space-y-2">
              <div className="text-sm text-gray-400">Legal</div>
              <div className="flex flex-col space-y-1">
                <a
                  href="/legal/privacy"
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200 text-sm"
                >
                  Privacy Policy
                </a>
                <a
                  href="/legal/terms"
                  className="text-gray-300 hover:text-blue-400 transition-colors duration-200 text-sm"
                >
                  Terms of Use
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="border-t border-gray-700 mt-8 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            Copyright © {currentYear} SP GxP Consultants. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};